import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './../AuthContext';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { site_url, invoice_img } from "./../config.js";
import { Formik } from 'formik';
import api from './../api.js';  // Use shared API with JWT token
import { IndianCurrencyFormatter, FormatDate } from './../Function';
import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { useLocation } from "react-router-dom";
import "./style.css";
import FloatRefreshButton from '../FloatRefreshButton';
import { FaAngleRight } from 'react-icons/fa';



function Index({ children }) {

  // ✅ Fixed: Added setUser and logout to AuthContext destructuring
  const { fulluser, setfullUser, vendordetails, setvendordetails, refreshUser, user, setUser, logout } = useContext(AuthContext);
  const [msg, setMsg] = useState([]);
  const [Iseligible, setIseligible] = useState(false);
  const [billcustomer, setbillcustomer] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('online');
  const [transactionlist, settransaction] = useState([]);
  const [pendingcash, setpendingcash] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [unpaidCommission, setUnpaidCommission] = useState(0);
  const [showCommissionAlert, setShowCommissionAlert] = useState(false);
  const [useCustomerReward, setUseCustomerReward] = useState(false);
  const [customerRewardAmount, setCustomerRewardAmount] = useState(0);
  const [otp, setOtp] = useState('');
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [rewardOtpCooldown, setRewardOtpCooldown] = useState(0); // seconds remaining to resend
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showPayCommissionModal, setShowPayCommissionModal] = useState(false);
  const [payCommissionAmount, setPayCommissionAmount] = useState('');
  const [walletBalance, setWalletBalance] = useState(0);
  const [showPaymentSuccessModal, setShowPaymentSuccessModal] = useState(false);
  const [paymentSuccessData, setPaymentSuccessData] = useState(null);
  const [pendingAmount, setPendingAmount] = useState(0);
  // Email Verification State
  const [showEmailVerify, setShowEmailVerify] = useState(false);
  const [emailOtp, setEmailOtp] = useState('');
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailVerifyMsg, setEmailVerifyMsg] = useState({ type: '', text: '' });
  const [verifyTimer, setVerifyTimer] = useState(0);
  const [canResendVerify, setCanResendVerify] = useState(true);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [vendorWalletLimit, setVendorWalletLimit] = useState({
    is_allow_cash: true,
    cash_limit: 0,
    todaycashbill: 0,
  });
  // Check if email verification reminder should be shown
  const shouldShowEmailReminder = (userDetails) => {
    if (!userDetails || (userDetails.email && userDetails.email_verified_at)) {
      return false;
    }

    const reminderKey = `email_reminder_${userDetails.id}`;
    const lastReminderTime = localStorage.getItem(reminderKey);

    if (!lastReminderTime) {
      // First time showing, set reminder for 3 days
      const reminderTime = new Date().getTime() + (3 * 24 * 60 * 60 * 1000); // 3 days
      localStorage.setItem(reminderKey, reminderTime.toString());
      return true;
    }

    const now = new Date().getTime();
    const reminderTime = parseInt(lastReminderTime);

    if (now >= reminderTime) {
      // Time to show reminder again, set for 1 week next time
      const nextReminderTime = now + (7 * 24 * 60 * 60 * 1000); // 1 week
      localStorage.setItem(reminderKey, nextReminderTime.toString());
      return true;
    }

    return false;
  };

  // Reward OTP resend cooldown timer (for customer reward OTP)
  useEffect(() => {
    if (rewardOtpCooldown <= 0) return;
    const t = setInterval(() => {
      setRewardOtpCooldown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(t);
  }, [rewardOtpCooldown]);

  const sendRewardOtp = async () => {
    const billAmountInput = document.querySelector('input[name="billamount"]');
    const taxInput = document.querySelector('input[name="tax"]');

    const billAmount = parseFloat(billAmountInput?.value || 0);
    const taxAmount = parseFloat(taxInput?.value || 0);
    const totalAmount = billAmount + taxAmount;

    if (totalAmount <= 0) {
      Swal.fire({
        title: 'Warning!',
        text: 'Please enter bill amount first before using customer reward points.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      const checkbox = document.getElementById('useCustomerReward');
      if (checkbox) checkbox.checked = false;
      return false;
    }

    const customerPhone = billcustomer?.customer?.phone;
    if (!customerPhone) {
      Swal.fire({
        title: 'Error!',
        text: 'Customer phone number not found',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      const checkbox = document.getElementById('useCustomerReward');
      if (checkbox) checkbox.checked = false;
      return false;
    }

    try {
      const otpResponse = await api.post('/customer/send-reward-otp', {
        phone: customerPhone
      });

      if (otpResponse.data.status === 'success') {
        console.log('OTP sent to customer:', otpResponse.data.otp);
        setShowOtpModal(true);
        setRewardOtpCooldown(60);
        return true;
      } else {
        Swal.fire({
          title: 'Error!',
          text: otpResponse.data.message || 'Failed to send OTP',
          icon: 'error',
          confirmButtonText: 'OK',
        });
        const checkbox = document.getElementById('useCustomerReward');
        if (checkbox) checkbox.checked = false;
        return false;
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to send OTP to customer',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      const checkbox = document.getElementById('useCustomerReward');
      if (checkbox) checkbox.checked = false;
      return false;
    }
  };

  // Handle "Remind Me Later" - set reminder for 3 days
  const handleRemindMeLater = (userDetails) => {
    const reminderKey = `email_reminder_${userDetails.id}`;
    const reminderTime = new Date().getTime() + (3 * 24 * 60 * 60 * 1000); // 3 days
    localStorage.setItem(reminderKey, reminderTime.toString());
    setShowEmailVerify(false);
  };

  const navigate = useNavigate();

  // const {  data: transactionList, isLoading, isError, error,refetchtransactions  } = useQuery({
  //   queryKey: ['transactions', user.id],  // Unique key to refetch when user.id changes
  //   queryFn: () => transaction(user),  // Pass user to the API function
  //   enabled: !!user.id,  // Prevent fetching if user.id is not available
  //   refetchInterval: 4000, 
  // });

  const transaction = async () => {
    try {
      // Use fulluser.id since it's now available from AuthContext
      if (!fulluser || !fulluser.id) {
        console.error('User ID not available');
        return;
      }

      const userData = { id: fulluser.id };
      console.log('Fetching transactions for user ID:', fulluser.id);

      const response = await api.post('/vendor/transtions', userData);
      settransaction(response.data.transtions);  // Axios auto-parses JSON
      console.log('Transactions loaded:', response.data.transtions);
    } catch (error) {
      console.error('Error fetching transactions:', error.response?.data?.message || 'Failed to fetch transactions');
    }
  };

  const currentDate = new Date();
  const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;

  const showSuccessAlert = () => {
    Swal.fire({
      title: 'Success!',
      text: 'Your bill has been created successfully',
      icon: 'success',
      confirmButtonText: 'OK',
    });
  };

  const location = useLocation();

  const pendingtransaction = async () => {
    try {
      // Use fulluser.id since it's now available from AuthContext
      if (!fulluser || !fulluser.id) {
        console.error('User ID not available');
        return;
      }

      const data = { id: fulluser.id };
      console.log('Fetching pending transactions for user ID:', fulluser.id);

      const response = await api.post('/vendor/pendingtranstions', data);
      setpendingcash(response.data.transtions);
      console.log('Pending transactions loaded:', response.data.transtions);
    } catch (error) {
      console.error('Error fetching pending transactions:', error.response?.data?.message || 'Failed to fetch transactions');
    }
  };

  const fetchUserData = async () => {
    const userId = localStorage.getItem('user_id');
    if (userId) {
      try {
        // Get vendor details using user_id (no token required)
        const userResponse = await api.get('/vendor/get-details-by-id?id=' + userId);

        if (userResponse.data && userResponse.data.data) {
          // Set full user data
          setfullUser(userResponse.data.data);
          // Then fetch vendor details
          const response = await api.get('/vendor/details/' + userId);
          setvendordetails(response.data);
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
        // If token is invalid, clear it and logout
        if (error.response && error.response.status === 401) {
          logout();
          navigate('/login');
        }
        setvendordetails(null);
      } finally {

      }
    }
  };


  const getVendorPendingamount = async () => {
    const userId = localStorage.getItem('user_id');

    if (!userId) {
      setPendingAmount(0);
      return;
    }

    try {
      const response = await api.post('/vendor/get-pending-amount', { vendor_id: userId });
      if (response.data.status === 'success') {
        setPendingAmount(response.data.net_balance);
      } else {
        setPendingAmount(0);
      }
    } catch (error) {
      console.error(
        'Error fetching pending amount:',
        error?.response?.data?.message || 'Failed to fetch pending amount'
      );
      setPendingAmount(0);
    } finally {
    }
  };

  useEffect(() => {
    getVendorPendingamount();
  }, []);

  const handleRefresh = () => {
    setIsLoading(true);
    console.log('Refreshing data...');

    // Refresh user data first, then fetch transactions
    // fetchUserData().then(() => {
    //   setTimeout(() => {
    //     if (fulluser && fulluser.id) {
    //       console.log('Data refreshed, fetching transactions...');
    transaction();
    pendingtransaction();
    fetchUserData();
    // checkUnpaidCommission();
    // fetchWalletBalance();
    //     }
    setIsLoading(false);
    //   }, 1000);
    // });
  };

  useEffect(() => {
    let interval;
    if (verifyTimer > 0) {
      interval = setInterval(() => {
        setVerifyTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResendVerify(true);
    }
    return () => clearInterval(interval);
  }, [verifyTimer]);

  const handleSendEmailOtp = async () => {
    try {
      const token = localStorage.getItem('access_token');
      if (!token) {
        setEmailVerifyMsg({ type: 'error', text: 'Authentication required. Please login again.' });
        return;
      }

      setEmailVerifyMsg({ type: 'info', text: 'Sending OTP...' });

      // Get vendor ID from localStorage
      const userId = localStorage.getItem('user_id');

      const res = await api.post('/vendor/send-email-otp', {
        vendor_id: userId,
        email: vendordetails?.user_details?.email
      });
      if (res.data.status === 'success') {
        setEmailOtpSent(true);
        setEmailVerifyMsg({ type: 'success', text: 'OTP sent to your email.' });
        setVerifyTimer(60);
        setCanResendVerify(false);
      } else {
        setEmailVerifyMsg({ type: 'error', text: res.data.message || 'Failed to send OTP.' });
      }
    } catch (err) {
      setEmailVerifyMsg({ type: 'error', text: err?.response?.data?.message || 'Error sending OTP.' });
    }
  };

  const handleVerifyEmailOtp = async () => {
    try {
      const userId = localStorage.getItem('user_id');
      if (!userId) {
        setEmailVerifyMsg({ type: 'error', text: 'Authentication required. Please login again.' });
        return;
      }

      const res = await api.post('/vendor/verify-email-otp', {
        vendor_id: userId,
        otp: emailOtp
      });
      if (res.data.status === 'success') {
        setShowEmailVerify(false);
        setShowSuccessModal(true);
        // fetchUserData(); // Refresh data
      } else {
        setEmailVerifyMsg({ type: 'error', text: res.data.message || 'Invalid OTP.' });
      }
    } catch (err) {
      setEmailVerifyMsg({ type: 'error', text: 'Verification failed.' });
    }
  };


  useEffect(() => {
    // Fetch fresh user data every time the home page loads
    fetchUserData();
  }, []);

  useEffect(() => {
    // Simple approach: if fulluser and fulluser.id are available, fetch all data
    if (fulluser && fulluser.id) {
      console.log('User data available, fetching transactions and other data...');
      transaction();
      pendingtransaction();
      // checkUnpaidCommission();
      //fetchWalletBalance();
    } else {
      console.log('User data not available yet, will retry...');
      // Retry after a short delay
      setTimeout(() => {
        if (fulluser && fulluser.id) {
          console.log('Retry: User data now available, fetching data...');
          transaction();
          pendingtransaction();
          // checkUnpaidCommission();
          //fetchWalletBalance();
        }
      }, 1000);
    }
  }, [fulluser]); // Depend on fulluser changes  

  const fetchWalletBalance = async () => {
    try {
      // Use fulluser.id since it's now available from AuthContext
      if (!fulluser || !fulluser.id) {
        console.error('User ID not found for wallet balance');
        return;
      }

      console.log('Fetching wallet balance for user ID:', fulluser.id);
      const response = await api.get('/vendor/details/' + fulluser.id);
      if (response.data) {
        const balance = response.data.vendor_online_wallet !== undefined
          ? parseFloat(response.data.vendor_online_wallet) || 0
          : (response.data.vendor_online ? parseFloat(response.data.vendor_online.replace(/,/g, '')) || 0 : 0);
        setWalletBalance(balance);
        console.log('Wallet balance loaded:', balance);
      } else {
        setWalletBalance(0);
      }
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      setWalletBalance(0);
    }
  };

  const handlePayCommission = async () => {
    const amount = Math.abs(parseFloat(vendorWalletLimit.vendor_current_payout_balance));
    if (!amount || amount <= 0) {
      Swal.fire({
        title: 'Error!',
        text: 'Please enter a valid amount',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    // if (amount > unpaid) {
    //   Swal.fire({
    //     title: 'Error!',
    //     text: `Amount cannot exceed unpaid commission of ₹${unpaid.toFixed(2)}`,
    //     icon: 'error',
    //     confirmButtonText: 'OK',
    //   });
    //   return;
    // }

    try {
      // Create Razorpay order for commission payment
      const vendorId = localStorage.getItem('user_id');
      const orderResponse = await api.post('/vendor/create-commission-order', {
        vendor_id: vendorId,
        amount: amount
      });

      if (orderResponse.data.status === 'success') {
        const { order_id, key, vendor_details } = orderResponse.data;

        const options = {
          key: key,
          amount: amount * 100, // Amount in paise
          currency: 'INR',
          name: 'APM Smart Hub',
          description: `Commission Payment - ${vendor_details.name}`,
          order_id: order_id,
          handler: async function (response) {
            try {
              console.log('Razorpay payment successful:', response);

              // Verify payment with backend
              const verifyResponse = await api.post('/vendor/verify-commission-payment', {
                vendor_id: localStorage.getItem('user_id'),
                razorpay_order_id: order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount: amount
              });

              console.log('Backend verification response:', verifyResponse.data);

              if (verifyResponse.data.status === 'success') {
                // Store payment success data
                setShowPurchaseModal(false);
                setPaymentSuccessData({
                  paidAmount: parseFloat(amount) || 0,
                  remainingUnpaid: Math.max(0, amount),
                  walletBalance: walletBalance, // Wallet balance unchanged
                  paymentDate: new Date().toLocaleString('en-IN', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  }),
                  paymentMethod: 'Razorpay',
                  paymentId: response.razorpay_payment_id
                });

                setPayCommissionAmount('');
                setShowPayCommissionModal(false);

                // Refresh data
                // await checkUnpaidCommission();
                refreshUser();

                // Show success modal
                setShowPaymentSuccessModal(true);
              } else {
                throw new Error(verifyResponse.data.message || 'Payment verification failed');
              }
            } catch (error) {
              console.error('Payment verification error:', error);
              // Swal.fire({
              //   title: 'Payment Failed!',
              //   text: error.response?.data?.message || error.message || 'Payment verification failed. Please contact support.',
              //   icon: 'error',
              //   confirmButtonText: 'OK',
              // });
            }
          },
          onpayment_failed: function (response) {
            console.error('Razorpay payment failed:', response);
            // Swal.fire({
            //   title: 'Payment Failed!',
            //   text: response.error?.description || 'Payment was not completed. Please try again.',
            //   icon: 'error',
            //   confirmButtonText: 'OK',
            // });
          },
          prefill: {
            name: vendor_details.name,
            email: vendor_details.email,
            contact: vendor_details.contact
          },
          notes: {
            vendor_id: localStorage.getItem('user_id'),
            type: 'commission_payment'
          },
          theme: {
            color: '#3399cc'
          },
          modal: {
            ondismiss: function () {
              // Handle modal dismissal if needed
              console.log('Payment modal dismissed');
            }
          }
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } else {
        throw new Error(orderResponse.data.message || 'Failed to create payment order');
      }
    } catch (error) {
      console.error('Commission payment error:', error);
      Swal.fire({
        title: 'Payment Failed!',
        text: error.response?.data?.message || 'Failed to initiate payment. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const makePayment = async (billamount, id) => {
    console.log({
      amount: billamount,
      order_id: id,

    });

    const res = await api.post("/pedingpayonlineorder", {
      amount: billamount,
      order_id: id,

    });
    console.log(res.data);

    const { razorpay_key, order_id, amount, currency } = res.data;

    const options = {
      key: razorpay_key,
      amount: amount,
      currency: currency,
      name: "APM",
      description: "Test Transaction",
      order_id: order_id,
      handler: async function (response) {
        try {
          console.log(response.razorpay_payment_id);


          const res = await api.post(
            "/pedingverifyPayment",
            {
              razorpay_payment_id: response.razorpay_payment_id,
              oid: id

            }
          );


          if (res.data.status === 'success') {
            // fetchUserData();
            pendingtransaction();
            transaction();
          } else {

            alert("Payment Failed. Please try again.");
          }

        } catch (err) {
          console.error("API Error:", JSON.stringify(err?.response?.data || { message: err.message }));
        }
      },
      prefill: {
        name: 'saravanan',
        email: "saravanan@example.com",
        contact: '7904123251'
      },
      theme: {
        color: "#3399cc"
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  useEffect(() => {
    // Handle body class and overflow for modals
    if (showPurchaseModal || showOtpModal) {
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "0px";
    } else {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [showPurchaseModal, showOtpModal]);


  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Check unpaid commission for cash payments
      const commissionResponse = await api.post('/vendor/check-unpaid-commission', {
        vendor_id: localStorage.getItem('user_id')
      });

      const commission = parseFloat(commissionResponse.data.unpaid_commission || 0);
      setUnpaidCommission(commission);

      if (commission > 0 && commissionResponse.data.require_payment) {
        setShowCommissionAlert(true);
        Swal.fire({
          title: 'Commission Payment Required!',
          html: `You have unpaid commission of <strong>₹${commission.toFixed(2)}</strong> for bills older than 24 hours.<br><br>Please pay admin commission before creating new bills.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Pay Admin Commission',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#007bff',
        }).then((result) => {
          if (result.isConfirmed) {
            // Navigate to commission payment page
            navigate('/commission-payment');
          }
        });
        setSubmitting(false);
        return;
      }

      // Check if customer reward is being used without OTP verification
      if (useCustomerReward && customerRewardAmount > 0) {
        // If useCustomerReward is true, it means OTP was verified successfully
        // No additional validation needed
        console.log('Customer reward points verified and ready to use');
      }

      // API request
      const billAmount = parseFloat(values.taxable || 0) + parseFloat(values.nontaxable || 0);
      const taxAmount = parseFloat(values.tax || 0);
      const totalBill = billAmount + taxAmount;
      const appliedWallet = useCustomerReward
        ? Math.min(parseFloat(customerRewardAmount || 0), totalBill)
        : 0;
      const data = {
        "customerid": billcustomer.customer.id,
        "billamount": billAmount,
        "billno": values.billno,
        "tax": taxAmount,
        "paytype": paymentMethod,
        "vendorid": localStorage.getItem('user_id'),
        "use_customer_reward": appliedWallet > 0,
        "customer_reward_amount": appliedWallet,
      }
      console.log(data);
      const response = await api.post('/vendor/billpay', data);
      console.log(response);
      if (response.data.status == 'success') {
        resetForm();
        setbillcustomer();
        setUseCustomerReward(false);
        setCustomerRewardAmount(0);
        setOtp('');
        setShowPurchaseModal(false);
        refreshUser();
        pendingtransaction();
        const purchaseBonus = parseFloat(response.data.purchase_bonus || 0);
        Swal.fire({
          title: 'Success!',
          html: purchaseBonus > 0
            ? `Bill created successfully.<br><strong>Purchase bonus ₹${purchaseBonus.toFixed(2)}</strong> credited to customer wallet.`
            : 'Your bill has been created successfully',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        setMsg(response.data)
      } else if (response.data.status == 'failed') {
        Swal.fire({
          title: 'Error!',
          text: response.data.msg || 'Failed to create bill',
          icon: 'error',
          confirmButtonText: 'OK',
        });
        setMsg(response.data)
      }
      // Reset form after success
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.msg || 'An error occurred',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setSubmitting(false); // Stop loading spinner
    }
  };
  const checkCashLimitcheck = async () => {
    try {
      const response = await api.get('/vendor/check-cash-limit/' + fulluser.id);
      if (response.data.status === 'success' && response.data.data) {
        const d = response.data.data;
        const allow =
          d.is_allow_cash === true ||
          d.is_allow_cash === 1 ||
          d.is_allow_cash === '1';
        setVendorWalletLimit({
          is_allow_cash: allow,
          cash_limit: parseFloat(d.cash_limit) || 0,
          todaycashbill: parseFloat(d.todaycashbill) || 0,
          vendor_current_payout_balance: parseFloat(d.vendor_current_payout_balance) || 0,
        });
        if (!allow) {
          setPaymentMethod('online');
        }
      }
    } catch (error) {
      console.error('Error checking cash limit:', error);
      setVendorWalletLimit({
        is_allow_cash: true,
        cash_limit: 0,
        todaycashbill: 0,
        vendor_current_payout_balance: 0,
      });
    }
  };
  const checkUnpaidCommission = async () => {
    try {
      // Use fulluser.id since it's now available from AuthContext
      if (!fulluser || !fulluser.id) {
        console.error('User ID not found for commission check');
        return 0;
      }

      console.log('Checking unpaid commission for user ID:', fulluser.id);
      const response = await api.get('/vendor/check-unpaid-commission/' + fulluser.id);
      if (response.data.status === 'success') {
        // Ensure the value is always a number
        const commission = parseFloat(response.data.unpaid_commission) || 0;
        setUnpaidCommission(commission);
        setShowCommissionAlert(response.data.show_alert || false);
        console.log('Unpaid commission loaded:', commission);
        return commission; // Return the value for immediate use
      }
      return 0;
    } catch (error) {
      console.error('Error checking unpaid commission:', error);
      return 0;
    }
  };

  const checkcustomerphone = async (ph) => {
    try {

      if (/^\d{10}$/.test(ph)) {
        console.log('check');
        // Add a small delay to prevent rapid API calls
        await new Promise(resolve => setTimeout(resolve, 300));
        const response = await api.get('/vendor/customer_check/' + ph);

        if (response.data.status == 'success') {
          setIseligible(true);
          let customerData = response.data;
          try {
            const walletRes = await api.get('/vendor/customer-wallet-balance/' + ph);
            if (walletRes.data.status === 'success') {
              const ledgerBalance = parseFloat(walletRes.data.available_balance ?? walletRes.data.wallet_balance ?? 0) || 0;
              customerData = {
                ...customerData,
                wallet_balance: ledgerBalance,
                ledger_wallet_balance: ledgerBalance,
              };
            }
          } catch (walletErr) {
            console.error('Error fetching customer ledger wallet balance:', walletErr);
          }
          setbillcustomer(customerData);
          const maxReward = customerData.wallet_balance || 0;
          if (customerRewardAmount > maxReward) {
            setCustomerRewardAmount(maxReward);
          }
        } else {
          setbillcustomer(response.data);
        }
      } else {
        setbillcustomer();
      }

    } catch (error) {

    }
  }

  const verifyOtp = async (otpValue) => {
    try {
      const response = await api.post('/vendor/verify-otp-reward', {
        otp: otpValue || otp
      });

      if (response.data.status === 'success') {
        setShowOtpModal(false);
        setOtp(otpValue || otp);
        return true;
      } else {
        Swal.fire({
          title: 'Error!',
          text: response.data.message || 'Invalid OTP. Please enter 1234 for testing.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
        return false;
      }
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'OTP verification failed. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return false;
    }
  };

  const handleUseRewardCheckbox = async (checked) => {
    if (checked) {
      // If OTP was sent recently (cooldown active), just reopen modal without sending again
      if (rewardOtpCooldown > 0) {
        setShowOtpModal(true);
        return;
      }

      // Otherwise send OTP (with validation inside helper)
      await sendRewardOtp();
    } else {
      // Uncheck and reset
      setUseCustomerReward(false);
      setCustomerRewardAmount(0);
      setOtp('');
    }
  };

  const handleOtpSubmit = async () => {
    if (!otp || otp.trim() === '') {
      Swal.fire({
        title: 'Error!',
        text: 'Please enter OTP',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    try {
      const customerPhone = billcustomer?.customer?.phone;

      // Verify OTP with new API
      const verifyResponse = await api.post('/customer/verify-reward-otp', {
        phone: customerPhone,
        otp: otp
      });

      if (verifyResponse.data.status === 'success') {
        // Only set to true after successful verification
        setUseCustomerReward(true);
        // Automatically set customer reward amount to total available
        const totalReward = parseFloat(billcustomer?.wallet_balance || 0);
        setCustomerRewardAmount(totalReward);

        // Close modal first
        setShowOtpModal(false);
        setOtp('');

        // Show success message with delay to ensure modal is closed
        setTimeout(() => {
          Swal.fire({
            title: 'Success!',
            text: `OTP verified. Customer reward points of ₹${totalReward.toFixed(2)} applied successfully.`,
            icon: 'success',
            confirmButtonText: 'OK',
            customClass: {
              popup: 'swal2-popup-custom'
            }
          });
        }, 300);
      } else {
        // If verification fails, ensure checkbox is unchecked
        setUseCustomerReward(false);
        setCustomerRewardAmount(0);
        Swal.fire({
          title: 'Error!',
          text: verifyResponse.data.message || 'Invalid OTP',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setUseCustomerReward(false);
      setCustomerRewardAmount(0);
      Swal.fire({
        title: 'Error!',
        text: 'OTP verification failed. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  return (
    <>
      <style>
        {`
          .swal2-popup-custom {
            z-index: 99999 !important;
          }
          .swal2-container {
            z-index: 99998 !important;
          }
        `}
      </style>

      <div id="appCapsule">
        {/* Wallet Card */}
        <div className="section wallet-card-section pt-1">
          <div className="wallet-card">
            {/* Balance */}
            <div className="balance">
              <div className="left">
                <h2 className="title">Today’s Sales</h2>
                <h1 className="total">₹ {vendordetails?.todaysBalance ?? '0'}</h1>
              </div>
              <div className="right">
                <center>
                  <a
                    href="#"
                    className="button"
                    onClick={async (e) => {
                      e.preventDefault();
                      setShowPurchaseModal(true);
                      const commission = await checkCashLimitcheck();
                      // const commission = await checkUnpaidCommission();
                      // // Show alert if unpaid commission exists
                      // if (pendingAmount < 0) {
                      //   Swal.fire({
                      //     title: 'Unpaid Commission',
                      //     html: `You need to pay ₹${pendingAmount.toFixed(2)} to admin as commission before creating new purchases.<br><br>Would you like to pay now?`,
                      //     icon: 'warning',
                      //     showCancelButton: true,
                      //     confirmButtonText: 'Pay Now',
                      //     cancelButtonText: 'Later',
                      //   }).then((result) => {
                      //     if (result.isConfirmed) {
                      //       // Open pay commission modal
                      //       setPayCommissionAmount(commission.toFixed(2));
                      //       setShowPayCommissionModal(true);
                      //     } else {
                      //       // Still open purchase modal but show warning inside
                      //       // setShowPurchaseModal(true);
                      //     }
                      //   });
                      // } else {
                      //   setShowPurchaseModal(true);
                      // }
                    }}
                  >
                    <ion-icon name="add-outline"></ion-icon>
                  </a>
                  <b>New Purchase</b>
                </center>
    
              </div>
              
            </div>

            {!vendorWalletLimit.is_allow_cash && (
    <div style={{backgroundColor: '#ff0000', color: '#ffffff', padding: '10px', borderRadius: '5px'}}>
     Daily Cash limit reached.
     
      
    </div>
  )}
          </div>
        </div>
        {/* Wallet Card */}
        {/* Deposit Action Sheet */}
        {showPurchaseModal && (
          <div
            className="modal fade action-sheet show"
            id="depositActionSheet"
            tabIndex={-1}
            role="dialog"
            style={{
              display: 'block',
              zIndex: 1050,
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              overflow: 'auto'
            }}
          >
            <div
              className="modal-backdrop fade show"
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 1040
              }}
              onClick={() => {
                setShowPurchaseModal(false);
                setUseCustomerReward(false);
                setCustomerRewardAmount(0);
                setOtp('');
              }}
            ></div>
            <div
              style={{
                position: 'relative',
                zIndex: 1051,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px'
              }}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setShowPurchaseModal(false);
                  setUseCustomerReward(false);
                  setCustomerRewardAmount(0);
                  setOtp('');
                }
              }}
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Sales Bill</h5>
                  </div>
                  <div className="modal-body">
                    <div className="action-sheet-content">
                      <Formik
                        initialValues={{ phone: '', billno: '', billamount: '', tax: '', confirmBillno: '', confirmBillamount: '', taxable: '', nontaxable: '' }}
                        validate={values => {
                          const errors = {};
                          if (
                            parseFloat(values.tax || 0) +
                            parseFloat(values.nontaxable || 0) +
                            parseFloat(values.taxable || 0) != parseFloat(values.billamount)
                          ) {
                            errors.taxable = " Bill amount (Taxable + Non-taxable + Tax) mismatch.";
                          }
                          if (!values.phone) {
                            errors.phone = 'Phone Number is required';
                          } else if (!/^\d{10}$/.test(values.phone)) {
                            errors.phone = 'Phone number must be exactly 10 digits';
                          }

                          if (!values.billno) {
                            errors.billno = 'Bill No is required';
                          }

                          if (!values.confirmBillno) {
                            errors.confirmBillno = 'Confirm Bill No is required';
                          } else if (values.confirmBillno !== values.billno) {
                            errors.confirmBillno = 'Bill No does not match';
                          }

                          if (!values.billamount) {
                            errors.billamount = 'Bill Amount is required';
                          }

                          if (!values.confirmBillamount) {
                            errors.confirmBillamount = 'Confirm Bill Amount is required';
                          } else if (values.confirmBillamount !== values.billamount) {
                            errors.confirmBillamount = 'Bill Amount does not match';
                          }

                          checkcustomerphone(values.phone);
                          return errors;
                        }}
                        onSubmit={handleSubmit}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          /* and other goodies */
                        }) => (
                          <form onSubmit={handleSubmit}>

                            <div className="form-group">
                              <label htmlFor="email">
                                <i className="fa fa-phone"></i>
                              </label>
                              <input type="number" name="phone" onChange={handleChange} onBlur={handleBlur} value={values.phone} placeholder="Enter Customer Mobile Number" />


                            </div>
                            {errors.phone && touched.phone && (<span className="error">{errors.phone}</span>)}
                            {billcustomer && billcustomer.customer && (
                              <label htmlFor="email">
                                <b style={{ color: 'green' }}><i className="fa fa-check-circle"></i> {billcustomer.customer.username}</b>
                                <span style={{ marginLeft: '8px', color: '#4B49AC', fontWeight: 'bold' }}>
                                  Wallet: ₹{parseFloat((billcustomer.ledger_wallet_balance ?? 0) || (billcustomer.wallet_balance ?? 0) || 0).toFixed(2)}
                                </span>
                              </label>
                            )}
                            {billcustomer && billcustomer.status == 'fail' && (
                              <label htmlFor="email">
                                <b style={{ color: 'red' }}><i className="fa fa-close"></i> Phone number not found</b>
                              </label>
                            )}
                            {billcustomer && billcustomer.status == 'success' && (
                              <div>

                                <label for="exampleInputEmail1"><b>Bill No</b></label>
                                <div className="form-group">

                                  <label htmlFor="email">
                                    <i className="fa fa-file"></i>
                                  </label>
                                  <input type="text" name="billno" onChange={handleChange} onBlur={handleBlur} value={values.billno} placeholder="Bill No" />


                                </div>
                                {errors.billno && touched.billno && (<div><span className="error">{errors.billno}</span><br></br></div>)}
                                <label><b>Confirm Bill No</b></label>
                                <div className="form-group">
                                  <label htmlFor="confirmBillno">
                                    <i className="fa fa-file"></i>
                                  </label>
                                  <input
                                    type="text"
                                    name="confirmBillno"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.confirmBillno}
                                    placeholder="Confirm Bill No"
                                  />
                                </div>
                                {errors.confirmBillno && touched.confirmBillno && (
                                  <div><span className="error">{errors.confirmBillno}</span><br /></div>
                                )}

                                <label for="exampleInputEmail1"><b>Total Bill Amount</b></label>
                                <div className="form-group">

                                  <label htmlFor="email">
                                    <i className="fa fa-inr"></i>
                                  </label>
                                  <input type="number" name="billamount" onChange={handleChange} onBlur={handleBlur} value={values.billamount} placeholder="Bill Amount" />


                                </div>
                                {errors.billamount && touched.billamount && (<div><span className="error">{errors.billamount}</span><br></br></div>)}


                                <label><b>Confirm Total Bill Amount</b></label>
                                <div className="form-group">
                                  <label htmlFor="confirmBillamount">
                                    <i className="fa fa-inr"></i>
                                  </label>
                                  <input
                                    type="number"
                                    name="confirmBillamount"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.confirmBillamount}
                                    placeholder="Confirm Bill Amount"
                                  />
                                </div>
                                {errors.confirmBillamount && touched.confirmBillamount && (
                                  <div><span className="error">{errors.confirmBillamount}</span><br /></div>
                                )}
                                <label for="exampleInputEmail1"><b>Taxable value</b></label>
                                <div className="form-group">

                                  <label htmlFor="email">
                                    <i className="fa fa-inr"></i>
                                  </label>
                                  <input type="number" name="taxable" onChange={handleChange} onBlur={handleBlur} value={values.taxable} placeholder="Taxable Amount" />
                                  {errors.tax && touched.tax && (<span className="error">{errors.tax}</span>)}


                                </div>

                                <label for="exampleInputEmail1"><b>Non-taxable Amount</b></label>
                                <div className="form-group">

                                  <label htmlFor="email">
                                    <i className="fa fa-inr"></i>
                                  </label>
                                  <input type="number" name="nontaxable" onChange={handleChange} onBlur={handleBlur} value={values.nontaxable} placeholder="Non-Taxable Amount" />


                                </div>


                                <label for="exampleInputEmail1"><b>Tax Amount</b></label>
                                <div className="form-group">

                                  <label htmlFor="email">
                                    <i className="fa fa-inr"></i>
                                  </label>
                                  <input type="number" name="tax" onChange={handleChange} onBlur={handleBlur} value={values.tax} placeholder="Tax Amount" />
                                  {errors.tax && touched.tax && (<span className="error">{errors.tax}</span>)}


                                </div>





                                <div >
                                  <center><h3 style={{ color: 'red', marginTop: '2%' }} >Total Amount : {(parseFloat(values.tax || 0) + parseFloat(values.nontaxable || 0) + parseFloat(values.taxable || 0))}</h3></center>
                                </div>
                                <div style={styles.paymentMethodSection}>
                                  <div style={styles.paymentMethodLabel}>Payment method</div>
                                  <div
                                    style={styles.optionContainer}
                                    role="radiogroup"
                                    aria-label="Payment method"
                                  >
                                    <div
                                      role="radio"
                                      aria-checked={paymentMethod === 'cash'}
                                      aria-disabled={!vendorWalletLimit.is_allow_cash}
                                      style={getPaymentOptionStyle(
                                        paymentMethod === 'cash' && vendorWalletLimit.is_allow_cash,
                                        !vendorWalletLimit.is_allow_cash
                                      )}
                                      onClick={() => {
                                        if (vendorWalletLimit.is_allow_cash) {
                                          setPaymentMethod('cash');
                                        }
                                      }}
                                      title={
                                        vendorWalletLimit.is_allow_cash
                                          ? 'Collect payment in cash at shop'
                                          : 'Daily cash limit reached'
                                      }
                                    >
                                      <i
                                        className={
                                          vendorWalletLimit.is_allow_cash
                                            ? 'fa fa-money-bill-alt'
                                            : 'fa fa-lock'
                                        }
                                        style={styles.icon}
                                      />
                                      <span>Cash (SHOP)</span>
                                      {!vendorWalletLimit.is_allow_cash && (
                                        <span style={styles.unavailableBadge}>Unavailable</span>
                                      )}
                                    </div>

                                    <div
                                      role="radio"
                                      aria-checked={paymentMethod === 'online'}
                                      style={getPaymentOptionStyle(paymentMethod === 'online', false)}
                                      onClick={() => setPaymentMethod('online')}
                                      title="Customer pays via APM online"
                                    >
                                      <i className="fa fa-shopping-cart" style={styles.icon} />
                                      <span>Online (APM)</span>
                                    </div>
                                  </div>
                                </div>
                                {!vendorWalletLimit.is_allow_cash && (
                                  <div style={styles.cashLimitPanel} role="alert">
                                    <div style={styles.cashLimitHeader}>
                                      <i
                                        className="fa fa-hand-paper-o"
                                        style={styles.cashLimitHeaderIcon}
                                        aria-hidden
                                      />
                                      <div style={styles.cashLimitHeaderText}>
                                        <div style={styles.cashLimitTitle}>Daily cash limit reached</div>
                                        <p style={styles.cashLimitBody}>
                                          Cash collection is paused until your payout balance is within the allowed limit.
                                          Use <strong>Online</strong> for this bill, or pay the balance below to unlock cash
                                          again.
                                        </p>
                                        {(vendorWalletLimit.cash_limit > 0 ||
                                          vendorWalletLimit.todaycashbill != null) && (
                                          <p style={styles.cashLimitMeta}>
                                            {vendorWalletLimit.cash_limit > 0 && (
                                              <>
                                                Limit: ₹
                                                {Number(vendorWalletLimit.cash_limit || 0).toLocaleString('en-IN')}
                                              </>
                                            )}
                                            {vendorWalletLimit.cash_limit > 0 &&
                                              vendorWalletLimit.todaycashbill != null &&
                                              ' · '}
                                            {vendorWalletLimit.todaycashbill != null && (
                                              <>
                                                {`Today's cash bills: ₹${Number(
                                                  vendorWalletLimit.todaycashbill || 0
                                                ).toLocaleString('en-IN')}`}
                                              </>
                                            )}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    <div style={styles.cashLimitAmountRow}>
                                      <span style={styles.cashLimitAmountLabel}>Balance to settle</span>
                                      <span style={styles.cashLimitAmountValue}>
                                        ₹
                                        {Number(vendorWalletLimit.vendor_current_payout_balance || 0).toLocaleString(
                                          'en-IN',
                                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                                        )}
                                      </span>
                                    </div>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-block"
                                      style={styles.cashLimitPayBtn}
                                      onClick={() => handlePayCommission()}
                                     
                                    >
                                      Pay balance online
                                    </button>
                                  </div>
                                )}

                                {/* <div>
                                  {paymentMethod === 'cash' && (
                                    <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                      <h3>Shop Payment</h3>
                                    </div>
                                  )}
                                  {paymentMethod === 'online' && (
                                    <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                      <h3>APM SmartHub Payment</h3>
                                    </div>
                                  )}
                                </div> */}
                                {/* Customer Reward Usage — cash and online, from ledger wallet */}
                                {(paymentMethod === 'cash' || paymentMethod === 'online') && billcustomer && billcustomer.customer && parseFloat(billcustomer.wallet_balance || 0) > 0 && (
                                  <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                      <input
                                        type="checkbox"
                                        id="useCustomerReward"
                                        checked={useCustomerReward}
                                        onChange={(e) => {
                                          if (!e.target.checked) {
                                            handleUseRewardCheckbox(false);
                                          } else {
                                            handleUseRewardCheckbox(true);
                                          }
                                        }}
                                        style={{ marginRight: '10px' }}
                                      />
                                      <label htmlFor="useCustomerReward" style={{ fontWeight: 'bold', cursor: 'pointer' }}>
                                        Use Customer Reward Points (₹{parseFloat(billcustomer.wallet_balance || 0).toFixed(2)})
                                      </label>
                                    </div>

                                    {useCustomerReward && (() => {
                                      const billTotal = parseFloat(values.taxable || 0) + parseFloat(values.nontaxable || 0) + parseFloat(values.tax || 0);
                                      const appliedReward = Math.min(parseFloat(customerRewardAmount || billcustomer.wallet_balance || 0), billTotal);
                                      const remainder = Math.max(0, billTotal - appliedReward);
                                      const remainderLabel = paymentMethod === 'online' ? 'Online to collect' : 'Cash to collect';
                                      return (
                                      <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#fff', borderRadius: '5px', border: '1px solid #28a745' }}>
                                        <p style={{ margin: 0, fontSize: '14px', color: '#28a745' }}>
                                          <strong>✅ Reward Points Applied:</strong> ₹{appliedReward.toFixed(2)}
                                        </p>
                                        <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#666' }}>
                                          Customer wallet debit: ₹{appliedReward.toFixed(2)}
                                        </p>
                                        <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#666' }}>
                                          {remainderLabel}: ₹{remainder.toFixed(2)}
                                        </p>
                                      </div>
                                      );
                                    })()}
                                  </div>
                                )}

                                {/* Unpaid Commission Warning */}
                                {(parseFloat(unpaidCommission) || 0) > 0 && (
                                  <div className="alert alert-warning" role="alert" style={{ marginTop: '15px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                      <div>
                                        <strong>⚠️ Commission Payment Required!</strong><br />
                                        You have unpaid commission of <strong>₹{(parseFloat(unpaidCommission) || 0).toFixed(2)}</strong> for bills older than 24 hours.
                                        <br />
                                        Please pay admin commission before creating new bills.
                                      </div>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={() => navigate('/commission-payment')}
                                        style={{ whiteSpace: 'nowrap' }}
                                      >
                                        <i className="fa fa-credit-card"></i> Pay Admin
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>)}
                            {errors.taxable && touched.taxable && (<span className="error">{errors.taxable}</span>)}

                            <div className="form-group basic">
                              <button

                                className="btn btn-danger btn-block btn-lg"
                                onClick={() => {
                                  setShowPurchaseModal(false);
                                  setUseCustomerReward(false);
                                  setCustomerRewardAmount(0);
                                  setOtp('');
                                }}
                              >
                                Close
                              </button>
                              <div style={{ width: '5%' }} />
                              {pendingcash.length <= 0 && (parseFloat(unpaidCommission) || 0) === 0 && (
                                <button
                                  type="submit"
                                  disabled={isSubmitting}
                                  className="btn btn-primary btn-block btn-lg"
                                // data-bs-dismiss="modal"
                                >
                                  {isSubmitting ? (
                                    <>
                                      <i className="fa fa-spinner fa-spin" aria-hidden="true" /> Processing...
                                    </>
                                  ) : (
                                    'Make Payment'
                                  )}
                                </button>
                              )}
                              {(parseFloat(unpaidCommission) || 0) > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-warning btn-block btn-lg"
                                  onClick={() => {
                                    setShowPurchaseModal(false);
                                    setPayCommissionAmount((parseFloat(unpaidCommission) || 0).toFixed(2));
                                    setShowPayCommissionModal(true);
                                  }}
                                >
                                  Pay Admin Commission (₹{(parseFloat(unpaidCommission) || 0).toFixed(2)}) - Direct Payment
                                </button>
                              )}

                            </div>
                            {pendingcash.length > 0 && (
                              <div class="alert alert-warning" role="alert">
                                Please clear the cash bill amount and send it to the admin.
                              </div>
                            )}
                          </form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* OTP Verification Modal - Customer Login Style */}
        {showOtpModal && (
          <div
            className="modal fade show"
            style={{
              display: 'block',
              zIndex: 1050,
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              overflow: 'auto'
            }}
          >
            <div
              className="modal-backdrop fade show"
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 1040
              }}
              onClick={() => {
                setShowOtpModal(false);
                setOtp('');
                // Ensure checkbox is unchecked if modal is closed
                setUseCustomerReward(false);
              }}
            ></div>
            <div
              style={{
                position: 'relative',
                zIndex: 1051,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px'
              }}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setShowOtpModal(false);
                  setOtp('');
                  // Ensure checkbox is unchecked if modal is closed
                  setUseCustomerReward(false);
                }
              }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                style={{ maxWidth: '400px', width: '100%' }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content" style={{ border: 'none', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
                  <div className="modal-header" style={{ border: 'none', padding: '30px 30px 0 30px', textAlign: 'center' }}>
                    <div style={{ marginBottom: '20px' }}>
                      <div style={{
                        width: '80px',
                        height: '80px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px auto',
                        border: '2px solid #e9ecef'
                      }}>
                        <i className="fa fa-shield-alt" style={{ fontSize: '30px', color: '#007bff' }}></i>
                      </div>
                      <h5 className="modal-title" style={{ fontSize: '24px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                        Verify Customer
                      </h5>
                      <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                        Enter OTP to use customer reward points
                      </p>
                    </div>
                    <button
                      type="button"
                      className="btn-close"
                      style={{ position: 'absolute', top: '15px', right: '15px' }}
                      onClick={() => {
                        setShowOtpModal(false);
                        setOtp('');
                        // Ensure checkbox is unchecked if OTP modal is closed without verification
                        setUseCustomerReward(false);
                      }}
                    ></button>
                  </div>
                  <div className="modal-body" style={{ padding: '0 30px 30px 30px' }}>
                    <div className="form-group mb-3">
                      <label htmlFor="otpInput" style={{ fontSize: '14px', fontWeight: '500', color: '#555', marginBottom: '8px', display: 'block' }}>
                        Customer Phone: {billcustomer?.customer?.phone || 'N/A'}
                      </label>
                      <input
                        type="text"
                        id="otpInput"
                        className="form-control"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                        placeholder="Enter 4-digit OTP"
                        maxLength="4"
                        autoFocus
                        style={{
                          fontSize: '18px',
                          textAlign: 'center',
                          letterSpacing: '8px',
                          height: '50px',
                          borderRadius: '10px',
                          border: '2px solid #e9ecef',
                          fontWeight: '600'
                        }}
                      />
                    </div>

                    <div style={{
                      backgroundColor: '#f8f9fa',
                      padding: '15px',
                      borderRadius: '10px',
                      textAlign: 'center',
                      border: '1px solid #e9ecef'
                    }}>
                      <p style={{ margin: 0, fontSize: '13px', color: '#666', lineHeight: '1.4' }}>
                        <i className="fa fa-info-circle" style={{ color: '#007bff', marginRight: '5px' }}></i>
                        OTP sent to customer: <strong>{billcustomer?.customer?.phone || 'N/A'}</strong>
                      </p>
                      <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#666' }}>
                        Please enter the 4-digit OTP received via SMS
                      </p>
                    </div>
                  </div>
                  <div className="modal-footer" style={{ border: 'none', padding: '0 30px 30px 30px', gap: '10px' }}>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{
                        flex: 1,
                        height: '45px',
                        borderRadius: '10px',
                        fontWeight: '500'
                      }}
                      onClick={() => {
                        setShowOtpModal(false);
                        setOtp('');
                        // Ensure checkbox is unchecked if cancelled
                        setUseCustomerReward(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      style={{
                        flex: 1,
                        height: '45px',
                        borderRadius: '10px',
                        fontWeight: '500'
                      }}
                      disabled={rewardOtpCooldown > 0}
                      onClick={() => {
                        if (rewardOtpCooldown > 0) return;
                        sendRewardOtp();
                      }}
                    >
                      {rewardOtpCooldown > 0 ? `Resend OTP (${rewardOtpCooldown}s)` : 'Resend OTP'}
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{
                        flex: 1,
                        height: '45px',
                        borderRadius: '10px',
                        fontWeight: '500',
                        backgroundColor: '#007bff',
                        borderColor: '#007bff'
                      }}
                      onClick={handleOtpSubmit}
                    >
                      Verify OTP
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Pay Commission to Admin Modal */}
        {showPayCommissionModal && (
          <div
            className="modal fade show"
            style={{
              display: 'block',
              zIndex: 1070,
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              overflow: 'auto'
            }}
          >
            <div
              className="modal-backdrop fade show"
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 1060
              }}
              onClick={() => {
                setShowPayCommissionModal(false);
                setPayCommissionAmount('');
              }}
            ></div>
            <div
              style={{
                position: 'relative',
                zIndex: 1071,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setShowPayCommissionModal(false);
                  setPayCommissionAmount('');
                }
              }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                style={{
                  maxWidth: '500px',
                  width: '90%',
                  margin: 'auto'
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Pay Commission to Admin</h5>
                    <button
                      type="button"
                      className="close"
                      onClick={() => {
                        setShowPayCommissionModal(false);
                        setPayCommissionAmount('');
                      }}
                    >
                      <span>&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="alert alert-info">
                      <strong>Unpaid Commission:</strong> ₹{(parseFloat(unpaidCommission) || 0).toFixed(2)}
                      <br />
                      <small>Pay commission directly via Razorpay (UPI/Card/Net Banking)</small>
                    </div>

                    <div className="form-group">
                      <label htmlFor="payCommissionAmount">
                        <strong>Amount to Pay (₹)</strong>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="payCommissionAmount"
                        value={payCommissionAmount}
                        onChange={(e) => setPayCommissionAmount(e.target.value)}
                        placeholder="Enter amount"
                        min="1"
                        max={unpaidCommission}
                        step="0.01"
                      />
                      <small className="form-text text-muted">
                        Maximum payable: ₹{(parseFloat(unpaidCommission) || 0).toFixed(2)}
                      </small>
                    </div>

                    <div className="form-group">
                      <button
                        type="button"
                        className="btn btn-success btn-block btn-lg"
                        onClick={handlePayCommission}
                        disabled={!payCommissionAmount || parseFloat(payCommissionAmount) <= 0}
                      >
                        <ion-icon name="card-outline" style={{ marginRight: '8px' }}></ion-icon>
                        Pay via Razorpay
                      </button>
                    </div>

                    <div className="form-group">
                      <button
                        type="button"
                        className="btn btn-secondary btn-block"
                        onClick={() => {
                          setShowPayCommissionModal(false);
                          setPayCommissionAmount('');
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Payment Success Modal */}
        {showPaymentSuccessModal && paymentSuccessData && (
          <div
            className="modal fade show"
            style={{
              display: 'block',
              zIndex: 1070,
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              overflow: 'auto'
            }}
          >
            <div
              className="modal-backdrop fade show"
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 1060
              }}
              onClick={() => {
                setShowPaymentSuccessModal(false);
                setPaymentSuccessData(null);
              }}
            ></div>
            <div
              style={{
                position: 'relative',
                zIndex: 1071,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setShowPaymentSuccessModal(false);
                  setPaymentSuccessData(null);
                }
              }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                style={{
                  maxWidth: '500px',
                  width: '90%',
                  margin: 'auto'
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                  <div className="modal-body" style={{ padding: '30px', textAlign: 'center' }}>
                    {/* Success Icon */}
                    <div style={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '50%',
                      backgroundColor: '#28a745',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 20px'
                    }}>
                      <ion-icon name="checkmark" style={{ fontSize: '50px', color: 'white' }}></ion-icon>
                    </div>

                    <h3 style={{ color: '#28a745', marginBottom: '20px', fontWeight: 'bold' }}>
                      Payment Successful!
                    </h3>

                    <div style={{
                      backgroundColor: '#f8f9fa',
                      borderRadius: '10px',
                      padding: '20px',
                      marginBottom: '20px',
                      textAlign: 'left'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <strong>Amount Paid:</strong>
                        <span style={{ color: '#28a745', fontWeight: 'bold', fontSize: '18px' }}>
                          ₹{(parseFloat(paymentSuccessData.paidAmount) || 0).toFixed(2)}
                        </span>
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <strong>Payment Date:</strong>
                        <span>{paymentSuccessData.paymentDate}</span>
                      </div>

                      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <strong>Remaining Unpaid:</strong>
                        <span style={{ color: (parseFloat(paymentSuccessData.remainingUnpaid) || 0) > 0 ? '#dc3545' : '#28a745', fontWeight: 'bold' }}>
                          ₹{(parseFloat(paymentSuccessData.remainingUnpaid) || 0).toFixed(2)}
                        </span>
                      </div> */}

                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <strong>Payment Method:</strong>
                        <span style={{ color: '#007bff', fontWeight: 'bold' }}>
                          {paymentSuccessData.paymentMethod || 'Wallet'}
                        </span>
                      </div>

                      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <strong>Wallet Balance:</strong>
                        <span style={{ fontWeight: 'bold' }}>
                          ₹{(parseFloat(paymentSuccessData.walletBalance) || 0).toFixed(2)}
                        </span>
                      </div> */}
                    </div>

                    {(parseFloat(paymentSuccessData.remainingUnpaid) || 0) <= 0 && (
                      <div className="alert alert-success" style={{ marginBottom: '20px' }}>
                        <strong>🎉 Great!</strong> All commission paid! You can now create new purchases.
                      </div>
                    )}

                    {(parseFloat(paymentSuccessData.remainingUnpaid) || 0) > 0 && (
                      <div className="alert alert-warning" style={{ marginBottom: '20px' }}>
                        <strong>Note:</strong> You still have ₹{(parseFloat(paymentSuccessData.remainingUnpaid) || 0).toFixed(2)} unpaid commission.
                      </div>
                    )}

                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          setShowPaymentSuccessModal(false);
                          setPaymentSuccessData(null);
                          // If all paid, optionally open purchase modal
                          if ((parseFloat(paymentSuccessData.remainingUnpaid) || 0) <= 0) {
                            setShowPurchaseModal(true);
                          }
                        }}
                        style={{ minWidth: '120px' }}
                      >
                        {(parseFloat(paymentSuccessData.remainingUnpaid) || 0) <= 0 ? 'Create Purchase' : 'OK'}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowPaymentSuccessModal(false);
                          setPaymentSuccessData(null);
                        }}
                        style={{ minWidth: '120px' }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Withdraw Action Sheet */}
        <div
          className="modal fade action-sheet"
          id="withdrawActionSheet"
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Withdraw Money</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  <form>
                    <div className="form-group basic">
                      <div className="input-wrapper">
                        <label className="label" htmlFor="account2d">
                          From
                        </label>
                        <select
                          className="form-control custom-select"
                          id="account2d"
                        >
                          <option value={0}>Savings (*** 5019)</option>
                          <option value={1}>Investment (*** 6212)</option>
                          <option value={2}>Mortgage (*** 5021)</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group basic">
                      <div className="input-wrapper">
                        <label className="label" htmlFor="text11d">
                          To
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="text11d"
                          placeholder="Enter IBAN"
                        />
                        <i className="clear-input">
                          <ion-icon name="close-circle" />
                        </i>
                      </div>
                    </div>
                    <div className="form-group basic">
                      <label className="label">Enter Amount</label>
                      <div className="input-group mb-2">
                        <span className="input-group-text" id="basic-addonb1">
                          $
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter an amount"
                          defaultValue={100}
                        />
                      </div>
                    </div>
                    <div className="form-group basic">
                      <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg"
                        data-bs-dismiss="modal"
                      >
                        Withdraw
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* * Withdraw Action Sheet */}
        {/* Send Action Sheet */}
        <div
          className="modal fade action-sheet"
          id="sendActionSheet"
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Send Money</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  <form>
                    <div className="form-group basic">
                      <div className="input-wrapper">
                        <label className="label" htmlFor="account2">
                          From
                        </label>
                        <select
                          className="form-control custom-select"
                          id="account2"
                        >
                          <option value={0}>Savings (*** 5019)</option>
                          <option value={1}>Investment (*** 6212)</option>
                          <option value={2}>Mortgage (*** 5021)</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group basic">
                      <div className="input-wrapper">
                        <label className="label" htmlFor="text11">
                          To
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="text11"
                          placeholder="Enter bank ID"
                        />
                        <i className="clear-input">
                          <ion-icon name="close-circle" />
                        </i>
                      </div>
                    </div>
                    <div className="form-group basic">
                      <label className="label">Enter Amount</label>
                      <div className="input-group mb-2">
                        <span className="input-group-text" id="basic-addon1">
                          $
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter an amount"
                          defaultValue={100}
                        />
                      </div>
                    </div>
                    <div className="form-group basic">
                      <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg"
                        data-bs-dismiss="modal"
                      >
                        Send
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* * Send Action Sheet */}
        {/* Exchange Action Sheet */}
        <div
          className="modal fade action-sheet"
          id="exchangeActionSheet"
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Exchange Money</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  <form>
                    <div className="row">
                      <div className="col-6">
                        <div className="form-group basic">
                          <div className="input-wrapper">
                            <label className="label" htmlFor="currency1">
                              From
                            </label>
                            <select
                              className="form-control custom-select"
                              id="currency1"
                            >
                              <option value={1}>EUR</option>
                              <option value={2}>USD</option>
                              <option value={3}>AUD</option>
                              <option value={4}>CAD</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="form-group basic">
                          <div className="input-wrapper">
                            <label className="label" htmlFor="currency2">
                              To
                            </label>
                            <select
                              className="form-control custom-select"
                              id="currency2"
                            >
                              <option value={1}>USD</option>
                              <option value={1}>EUR</option>
                              <option value={2}>AUD</option>
                              <option value={3}>CAD</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group basic">
                      <label className="label">Enter Amount</label>
                      <div className="input-group mb-2">
                        <span className="input-group-text" id="basic-addon2">
                          $
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter an amount"
                          defaultValue={100}
                        />
                      </div>
                    </div>
                    <div className="form-group basic">
                      <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg"
                        data-bs-dismiss="modal"
                      >
                        Exchange
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* * Exchange Action Sheet */}
        {/* Stats */}
        <div className="section">

          <div className="row mt-2">
            <div class="section-heading"><h2 class="title">{formattedDate}</h2></div>
            <div className="col-6">
              <div className="stat-box">
                <div className="title">Today Cash Sales</div>
                <div className="value text-success">₹ {(vendordetails ? vendordetails.todayvendor_cash : '0')}</div>
              </div>
            </div>
            <div className="col-6">
              <div className="stat-box">
                <div className="title">Today Online Sales</div>
                <div className="value text-danger">₹ {(vendordetails ? vendordetails.todayvendor_online : '0')}</div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">
              <div className="stat-box">
                <div className="title">Total Cash</div>
                <div className="value">₹ {(vendordetails ? vendordetails.vendor_cash : '0')}</div>
              </div>
            </div>
            <div className="col-6">
              <div className="stat-box">
                <div className="title">Total Online</div>
                <div className="value">₹ {(vendordetails ? vendordetails.vendor_online : '0')}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="section mt-4">
          <div className="section-heading">
            <h2 className="title">Pending Bill</h2>


          </div>



          <div className="transactions">
            {pendingcash.length > 0 && (
              <div class="alert alert-danger mb-2" role="alert">
                Please clear the cash bill amount and send it to the admin.
              </div>
            )}


            {pendingcash?.map((item) => (


              <Link onClick={() => makePayment((parseFloat(item.billamount) + parseFloat(item.tax)), item.id)} className="item">

                <div className="detail">
                  <img
                    src={invoice_img}
                    alt="img"
                    className="image-block imaged w48"
                  />
                  <div>
                    <strong>#{item.billno}</strong> (Token: <span style={{ color: 'red' }}>{item.token_no}</span>)
                    <p>{(item.date_time)}</p>
                    {/* {(item.is_paid == '0' ? 
                  <span class="badge badge-success">Paid</span>
                  :
                  <span class="badge badge-danger">Un-Paid</span>
                  )} */}
                    {item.is_paid == '0' && (
                      <span className="badge badge-success">Paid</span>
                    )}
                    {item.is_paid == '1' && (
                      <span className="badge badge-danger">Pending Bill</span>
                    )}
                    {item.is_paid == '2' && (
                      <span className="badge badge-warning">Cancelled</span>
                    )}
                  </div>
                </div>
                <div className="right">
                  <div className="price text-danger">
                    <IndianCurrencyFormatter amount={(parseFloat(item.billamount) + parseFloat(item.tax)) - parseFloat(item.customer_reward_used || 0)} />
                  </div>
                </div>
              </Link>

            ))}



          </div>
        </div>
        <div className="section mt-4">
          <div className="section-heading">
            <h2 className="title">Transactions</h2>
            <Link to={`/Transaction`} className="link">
              View All
            </Link>

          </div>
          <div className="transactions">
            {/* item */}


            {transactionlist?.map((item) => (


              <Link to={`/Payment?id=${item.id}`} className="item">

                <div className="detail">
                  <img
                    src={invoice_img}
                    alt="img"
                    className="image-block imaged w48"
                  />
                  <div>
                    <strong>#{item.billno}</strong> (Token: <span style={{ color: 'red' }}>{item.token_no}</span>)
                    <p>{(item.date_time)}</p>
                    {/* {(item.is_paid == '0' ? 
                  <span class="badge badge-success">Paid</span>
                  :
                  <span class="badge badge-danger">Un-Paid</span>
                  )} */}
                    {item.paytype === 'cash' && (
                      <div style={{ marginTop: '4px' }}>
                        {item.is_paid == '0' ? (
                          <span className="badge badge-success">Paid (Cash)</span>
                        ) : (
                          <span className="badge badge-danger">Unpaid (Cash)</span>
                        )}
                      </div>
                    )}
                    {item.paytype === 'online' && (
                      <div style={{ marginTop: '4px' }}>
                        {item.is_paid == '0' ? (
                          <span className="badge badge-success">Paid (Online)</span>
                        ) : (
                          <div>
                            
                          <span className="badge badge-warning">Pending (Online)</span>
                          </div>
                        )}
                      </div>
                    )}
                    {item.is_paid == '2' && (
                      <div style={{ marginTop: '4px' }}>
                        <span className="badge badge-warning">Cancelled</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="right">
                  <div className="price text-danger"><IndianCurrencyFormatter amount={(parseFloat(item.billamount) + parseFloat(item.tax))} /></div>
                  {/* {item.customer_reward_used > 0 && (
                    <div className="text-success" style={{ fontSize: '0.8em', fontWeight: 'bold' }}>
                      Reward Used: <IndianCurrencyFormatter
                        amount={(() => {
                          const reward = parseFloat(item.customer_reward_used);
                          const dbComm = parseFloat(item.admin_commission_amount);
                          const comm = (dbComm > 0) ? dbComm : ((parseFloat(item.billamount) + parseFloat(item.tax)) * parseFloat(item.admincommisition) / 100);
                          return Math.max(0, reward - comm);
                        })()}
                      />
                    </div>
                  )} */}
                </div>
              </Link>

            ))}



          </div>
        </div>
        <FloatRefreshButton onRefresh={handleRefresh} />

        {isLoading && (
          <div style={{ position: 'fixed', bottom: '40%', right: '40%' }}>
            <img src="https://cdn.pixabay.com/animation/2023/11/09/03/05/03-05-45-320_512.gif" alt="Loading..." width={40} height={40} />
          </div>
        )}
      </div>
      <Footer />
      <Sidebar />

      {/* Email Verification Action Sheet Modal */}
      {showEmailVerify && (
        <div
          className="modal fade action-sheet show"
          id="emailVerifyActionSheetUser"
          tabIndex={-1}
          role="dialog"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Account Security</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  <div className="text-center mb-2">
                    <div
                      style={{
                        width: '80px',
                        height: '80px',
                        backgroundColor: 'rgba(98, 54, 255, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px auto'
                      }}
                    >
                      <ion-icon name="mail-unread-outline" style={{ fontSize: '40px', color: '#6236FF' }}></ion-icon>
                    </div>
                  </div>
                  <h3 className="text-center mb-1">Verify Your Email</h3>
                  <p className="text-center mb-3">
                    To ensure you receive monthly statements and important account updates, please verify your email address.
                  </p>

                  <div className="d-flex justify-content-center gap-2 mt-3 p-2">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm flex-fill"
                      onClick={() => {
                        setShowEmailVerify(false);
                        navigate('/Settings');
                      }}
                    >
                      Go to Profile
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm flex-fill"
                      onClick={() => handleRemindMeLater(vendordetails?.user_details)}
                    >
                      Remind Me Later
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Verification Success Modal */}
      {showSuccessModal && (
        <div
          className="modal fade action-sheet show"
          id="successActionSheet"
          tabIndex={-1}
          role="dialog"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Success</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  <div className="text-center mb-2">
                    <div
                      style={{
                        width: '80px',
                        height: '80px',
                        backgroundColor: 'rgba(50, 168, 82, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px auto'
                      }}
                    >
                      <ion-icon name="checkmark-circle-outline" style={{ fontSize: '40px', color: '#32a852' }}></ion-icon>
                    </div>
                  </div>
                  <h3 className="text-center mb-1">Email Verified!</h3>
                  <p className="text-center mb-3">
                    Your email has been successfully verified. You will now receive monthly statements and important updates.
                  </p>

                  <div className="form-group basic">
                    <button
                      type="button"
                      className="btn btn-primary btn-block btn-lg"
                      onClick={() => setShowSuccessModal(false)}
                    >
                      Great!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </>

  )
}
const getPaymentOptionStyle = (isSelected, isDisabled) => {
  if (isDisabled) {
    return { ...styles.option, ...styles.optionDisabled };
  }
  return isSelected ? styles.selectedOption : styles.option;
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '15px',
    fontFamily: 'Arial, sans-serif',
  },
  paymentMethodSection: {
    marginTop: 15,
  },
  paymentMethodLabel: {
    textAlign: 'center',
    fontSize: 14,
    fontWeight: 600,
    color: '#444',
    marginBottom: 10,
    letterSpacing: '0.02em',
  },
  optionContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '16px',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '14px 24px',
    border: '2px solid #d1d5db',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    fontSize: '15px',
    fontWeight: 500,
    backgroundColor: '#84848429',
    color: '#374151',
    minHeight: '50px',
    userSelect: 'none',
  },
  selectedOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '14px 24px',
    border: '2px solid #16a34a',
    borderRadius: '10px',
    cursor: 'pointer',
    backgroundColor: '#16a34a',
    color: '#fff',
    fontSize: '15px',
    fontWeight: 600,
    minHeight: '50px',
    boxShadow: 'rgb(7 34 17 / 77%) 0px 4px 12px',
    userSelect: 'none',
  },
  optionDisabled: {
    opacity: 0.65,
    cursor: 'not-allowed',
    borderColor: '#d1d5db',
    backgroundColor: '#f3f4f6',
    color: '#9ca3af',
    boxShadow: 'none',
  },
  unavailableBadge: {
    marginLeft: 4,
    padding: '2px 8px',
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    backgroundColor: '#fee2e2',
    color: '#b91c1c',
  },
  icon: {
    fontSize: '16px',
  },
  result: {
    marginTop: '20px',
    fontSize: '16px',
  },
  cashLimitPanel: {
    marginTop: 16,
    padding: '16px 18px',
    borderRadius: 12,
    border: '1px solid #fcd34d',
    background: 'linear-gradient(165deg, #fffbeb 0%, #fef3c7 100%)',
    boxShadow: '0 2px 8px rgba(180, 83, 9, 0.08)',
  },
  cashLimitHeader: {
    display: 'flex',
    gap: 14,
    alignItems: 'flex-start',
    marginBottom: 14,
  },
  cashLimitHeaderIcon: {
    fontSize: 22,
    color: '#b45309',
    marginTop: 2,
    flexShrink: 0,
  },
  cashLimitHeaderText: {
    flex: 1,
    minWidth: 0,
  },
  cashLimitTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: '#92400e',
    marginBottom: 6,
    lineHeight: 1.3,
  },
  cashLimitBody: {
    margin: 0,
    fontSize: 13,
    lineHeight: 1.5,
    color: '#78350f',
    textAlign: 'left',
  },
  cashLimitMeta: {
    margin: '10px 0 0 0',
    fontSize: 12,
    color: '#a16207',
    fontWeight: 600,
    textAlign: 'left',
  },
  cashLimitAmountRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 14px',
    marginBottom: 12,
    borderRadius: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    border: '1px solid rgba(180, 83, 9, 0.2)',
  },
  cashLimitAmountLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: '#78350f',
  },
  cashLimitAmountValue: {
    fontSize: 17,
    fontWeight: 700,
    color: '#b45309',
    letterSpacing: '0.02em',
  },
  cashLimitPayBtn: {
    fontWeight: 600,
    padding: '12px 16px',
    borderRadius: 8,
    boxShadow: '0 2px 4px rgba(37, 99, 235, 0.25)',
  },
};
export default Index